import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { DownloadService } from './download.service';
import { environment } from '@environments/environment';


export interface ExportRequest {
    name: string;
    params?: Map<string, any>;
}

@Injectable({ providedIn: 'root' })
export class ExportService {

    private readonly baseUrl = `${environment.http.apiRoot}/export`;

    constructor(private http: HttpClient, private downloadService: DownloadService) {}

    export(exportRequest: ExportRequest) {
        return this.http.post(this.baseUrl, exportRequest, {
            responseType: 'blob',
            observe: 'response',
        }).subscribe(response => {
            this.downloadService.downloadFile(response, '');
        });
    }
}
